<card class="u-flex BarGraph" [config]="{ ignorePadding: true }">
  <div body class="BarGraph__Container">
    <div class="BarGraph__CustomContent">
      <ng-content select="[aboveGraphContent]"></ng-content>
    </div>
    @if (config) {
      <div>
        <bar-graph [config]="config" [data]="data"> </bar-graph>
      </div>
    }
    <div class="BarGraph__CustomContent">
      <ng-content select="[belowGraphContent]"></ng-content>
    </div>
  </div>
</card>
